import { render, staticRenderFns } from "./MyRounds.vue?vue&type=template&id=0c8f8d8b&"
import script from "./MyRounds.vue?vue&type=script&lang=js&"
export * from "./MyRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports